import { LicenseInfo } from '@mui/x-license-pro';

import appEnv from '../configuration/appEnv';

const initializeMuiPro = () => {
	LicenseInfo.setLicenseKey(appEnv.muiLicense ?? '');
};
export default initializeMuiPro;
